import PropTypes from 'prop-types';

const JsonSection = ({ data, content }) => {
  return (
    <div className="mt-2">
      <pre className="p-2 bg-gray-50 rounded-md text-xs whitespace-pre-wrap">
        {JSON.stringify(data || { content }, null, 2)}
      </pre>
    </div>
  );
};

JsonSection.propTypes = {
  data: PropTypes.object,
  content: PropTypes.string
};

export default JsonSection; 